import React, { Component } from 'react'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link } from 'react-router'
import moment from 'moment'
import numeral from 'common/lib/numeral'
import classNames from 'classnames'
import PropTypes from 'prop-types';
import { first, last, map, filter, has, keyBy, find, reduce, forEach, sortBy } from 'lodash'

function calculateYearInterval (inspection_start, interval) {
  let years = [inspection_start] // eslint-disable-line prefer-const
  for (let i = 1; i < 15; i++) {
    if (i % interval === 0) {
      years.push(inspection_start + i)
    }
  }
  return years
}

const MaintenanceRow = ({ part, estimates: { by_id, by_year }, years, customer_id, current_year, showPartHandler, classes, projects }) => {
  const { id, title } = part

  const currentYear = by_year[current_year]
  const currentEstimate = currentYear ? currentYear[id] : null
  let projectByPart = []

  const amount = projects.reduce((acc, p) => {
    if (p.part_id == part.id && p.year == current_year) {
      acc += p.amount
      if (!projectByPart[part.id]) {
        projectByPart[part.id] = []
      }
      if (p.show_in_list) {
        projectByPart[part.id].push(p)
      }
    }
    return acc
  }, 0)
  
  return (
    <div className={`${classes.infoTable} ${classes.cursor}`} onClick={ showPartHandler(part.id, 'maintenance')}>
        <Typography className={classes.greyTextMedium} component="div">
            {part.title}
            {projectByPart[part.id] ? projectByPart[part.id].map(p => <p>{p.title}</p>) : null}
        </Typography>
        <Typography className={classes.blueText}>
            { numeral(currentEstimate && by_id[currentEstimate].estimate ? by_id[currentEstimate].estimate * 1000 : amount).format('0,0') }
        </Typography>
    </div>
    // <TableRow className={classes.cursor} onClick={ showPartHandler(part.id, 'maintenance') }>
    //   <TableCell className={classes.underline}>
    //     <span>{ part.title }</span>
    //     {projectByPart[part.id] ? projectByPart[part.id].map(p => <p>{p.title}</p>) : null}
    //   </TableCell>
    //   {/* <TableCell>{ part.amount }</TableCell> */}
    //   <TableCell align="right">{ numeral(currentEstimate && by_id[currentEstimate].estimate ? by_id[currentEstimate].estimate * 1000 : amount).format('0,0') }</TableCell>
    // </TableRow>
  )
}
MaintenanceRow.propTypes = {
  part: PropTypes.object.isRequired,
  estimates: PropTypes.object.isRequired,
  years: PropTypes.array.isRequired,
  customer_id: PropTypes.string.isRequired,
  current_year: PropTypes.number.isRequired,
  showPartHandler: PropTypes.func.isRequired,
}

class ActivityTable extends Component {

  render () {
    const {classes, year, maintenance_parts, allProjects, years, customer_id, estimates, inspection_parts_by_year, toggleModal} = this.props;
    const maintenanceRows = map(maintenance_parts, (part, idx) => <MaintenanceRow projects={allProjects} key={ idx } part={ part } years={ years } customer_id={ customer_id } current_year={ year } estimates={ estimates } showPartHandler={ toggleModal }  classes={classes} />)
    const maintenanceHeaders = [
      'Bygningsdel',
      //'Mængde',
      'Omkostninger',
    ]
    const extraordinaryHeaders = [
      'Bygningsdel', 'Omkostninger',
    ]

    const inspectionHeaders = [
      'Bygningsdel',
      //'Mængde',
    ]
    const current_inspection = inspection_parts_by_year[year]

    const subtotal = estimates.totals.by_year[year]
    const scaffolding_construction_total = estimates.totals.by_year_for_sc[year] ? numeral(estimates.totals.by_year_for_sc[year] * 1000).format('0,0') : 0
    const adviser_building_management_total = estimates.totals.by_year_for_ab[year] ? numeral(estimates.totals.by_year_for_ab[year] * 1000).format('0,0') : 0
    const extraordinary_total = estimates.totals.extraordinary_by_year[year] || 0
    const total = subtotal + extraordinary_total
    const totalFormatted = total ? total * 1000 : 0
    return (
        <Grid item sm={12} md={6} lg={4}>
            <TableContainer component={Paper} className={classes.paper}>
                <Typography className={`${classes.tablePadding} ${classes.header}`} variant="h5">
                    Projektbudget { year }
                </Typography>
                <div className={classes.maintenanceHeaders}>
                    { maintenanceHeaders.map((header, idx) => <div key={idx}>{header}</div>)}
                </div>
                <div className={classes.infoTableContainer}>
                    {maintenanceRows}
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyTextMedium}>
                            Stillads og byggeplads
                        </Typography>
                        <Typography className={classes.blueText}>
                            { scaffolding_construction_total }
                        </Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyTextMedium}>
                            Teknisk rådgiver og byggesagsadministration
                        </Typography>
                        <Typography className={classes.blueText}>
                            { adviser_building_management_total }
                        </Typography>
                    </div>
                    <div className={classes.infoTable}>
                        <Typography className={classes.greyTextMedium}>
                            Moms
                        </Typography>
                        <Typography className={classes.blueText}>
                            { numeral(totalFormatted * 0.25).format('0,0') }
                        </Typography>
                    </div>
                    <div className={`${classes.infoTable} ${classes.infoTableTotal}`}>
                        <Typography className={classes.greyTextMedium}>
                            Total
                        </Typography>
                        <Typography className={classes.blueText}>
                            { numeral(totalFormatted * 1.25).format('0,0') }
                        </Typography>
                    </div>
                </div>
                 <div className={`${classes.maintenanceHeaders} ${classes.greyTextMedium}`}>Prisen er ekskl. finansiering, forsikring, uforudsigelige udgifter mv. Vi anbefaler I kontakter en rådgiver for at få udarbejdet et specificeret projektoverslag</div>
            </TableContainer>
        </Grid>
    )
  }
}


const mapStateToProps = (state, props) => {
  const estimates = state.data.customer.estimates
  const parts = keyBy(state.data.customer.parts, 'id')
  let filteredEstimatesById = filter(estimates.by_id, estimate => {
    return estimate.estimate !== null && estimate.estimate !== 0
  })
  let filteredProjectsById = filter(state.data.customer.projects, project => {
    return project.year == props.year
  })
  filteredEstimatesById = keyBy(filteredEstimatesById, 'id')
  filteredProjectsById = keyBy(filteredProjectsById, 'part_id')
  const maintenance_parts = filter(parts, part => {
    if (has(filteredProjectsById, part.id)) {
        return true;
    }
    return (estimates.by_year[props.year] && estimates.by_year[props.year][part.id]) && (has(filteredEstimatesById, estimates.by_year[props.year][part.id]) || has(filteredProjectsById, part.id))
  })
  const inspection_parts_by_year = reduce(parts, (acc, part) => {
    const { inspection_start, inspection_interval } = part
    const year_intervals = inspection_start && inspection_interval
      ? calculateYearInterval(part.inspection_start, part.inspection_interval)
      : []
    forEach(year_intervals, (year, idx) => {
      acc[year] = acc[year] || []
      acc[year].push(part.id)
    })
    return acc
  }, {})
  return {
        years: state.data.years.years,
        allProjects: state.data.customer.projects,
        maintenance_parts,
        estimates,
        inspection_parts_by_year
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ActivityTable))
